import { render, staticRenderFns } from "./RightSDKWinTask.vue?vue&type=template&id=aeaf69e0&scoped=true&"
import script from "./RightSDKWinTask.vue?vue&type=script&lang=js&"
export * from "./RightSDKWinTask.vue?vue&type=script&lang=js&"
import style0 from "./RightSDKWinTask.vue?vue&type=style&index=0&id=aeaf69e0&prod&scoped=true&lang=scss&"
import style1 from "./RightSDKWinTask.vue?vue&type=style&index=1&id=aeaf69e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeaf69e0",
  null
  
)

export default component.exports